import React, { useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { IBlogPost } from "utils/types"
import { convertBodyToJSX } from "utils/helpers"
import SocialLinks from "./components/SocialLinks"

interface BlogViewProps {
  post: IBlogPost
}
export default function BlogView({ post }: BlogViewProps) {
  // Let all links of the blog post open externally in a new tab
  useEffect(() => {
    document
      .querySelectorAll(".post-body a")
      .forEach(x => x.setAttribute("target", "__blank"))
  }, [])

  return (
    <div className="blog-view post">
      <div className="post-header">
        <div className={"titles"}>
          <h1 className="">{post.title}</h1>
          <h3 className="">{post.subtitle}</h3>
        </div>

        <div className="meta">
          <div className={"about-post"}>
            <small className={"label"}>{post.authorName}</small>
            <small className={"label"}>&middot;</small>
            <small className={"label"}>{post.date || post.createdAt}</small>
            <SocialLinks {...post} />
          </div>
          {post.authorImage && (
              <GatsbyImage
                  className="author-image"
                  alt={`Image of ${post.authorName}`}
                  image={post.authorImage.gatsbyImageData}
              />
          )}
        </div>

      </div>

      {post.image && (
          <GatsbyImage
              className="image"
              alt="post image"
              image={post.image.gatsbyImageData}
          />
      )}

      <div className="post-content">
        <h3>
          {post.captionText}
        </h3>
        <div className="post-body html-body">
          {convertBodyToJSX(post.body)}
        </div>
      </div>
    </div>
  )
}
